// extracted by css-extract-rspack-plugin
export default {"sidebarContent":"IssueSidebar-module__sidebarContent__HKaGK","copilotAssignmentButton":"IssueSidebar-module__copilotAssignmentButton__lnAmT"};